import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

function Getintouch() {
  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, []);
  return (
    <div id="contact" className="container sec-pad">
      <div className="wrapper mx-auto" data-aos="fade-up">
        <h2 className="fw-bolder">Get in Touch</h2>
        <p>We want to hear from you as this helps us serve you better.</p>
        <form>
          <input type={"text"} placeholder="Your Name" />
          <input type={"text"} placeholder="Your Email" />
          <input type={"text"} placeholder="Your Message" />
          <a href="/Pagenotfound.html" className="btn btn-secondary mt-10">
            Submit
          </a>
        </form>
      </div>
    </div>
  );
}

export default Getintouch;
